import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { ciandtspikeOnboardingTranslations } from './resource';

const onboardingTranslations = TranslationBlueprint.make({
  name: 'ciandtspike-onboarding',
  params: { resource: ciandtspikeOnboardingTranslations },
});

// TranslationBlueprint só aceita extensions do plugin `app`, portanto é
// entregue como FrontendModule do `app` para o host registrar em features[].
export const ciandtspikeOnboardingTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [onboardingTranslations],
});
